import Helper from "./Helper";

class SubnavigationFunctionality {
  constructor(config = {}) {
    this.body = document.querySelector("body");
    this.mainWrapper = document.querySelector('.main-wrapper');
    this.subNavigation = document.querySelector('.subpageNavigation');
    this.suNaviItem = [...document.querySelectorAll('.subpageNavigation__item')];
    this.header = document.querySelector('.ns-header');
    this.subnaviLinks = [...document.querySelectorAll('.subpageNavigation__link')];
    this.subNavigationLinksLevel2 = [...document.querySelectorAll('.subpageNavigation__item-level2 > .menu__link--level-2')];

    this.stickyObserver();

    if (this.subnaviLinks && this.subnaviLinks.length > 0) {
      this.bindEvents();
      this.addActiveClassToLinks();  // Call the function after events are bound
    }
  }

  stickyObserver() {
    const stickyElm = this.subNavigation;

    if (!stickyElm) return;

    const observer = new IntersectionObserver(
      ([e]) => e.target.classList.toggle('isSticky', e.intersectionRatio < 1),
      { threshold: [1] }
    );

    observer.observe(stickyElm);
  }

  bindEvents() {
    let heightOfContentContainer = this.calculateHeight(this.mainWrapper);

    window.addEventListener('resize', () => {
      heightOfContentContainer = this.calculateHeight(this.mainWrapper);
      this.subnaviLinks.forEach((el) => {
        Helper.removeClass(el.parentNode, 'active');
        let elForHeight = el.parentNode.querySelector('.subpageNavigation__wrap-level2');
        elForHeight.style.height = '0px';
      });
    });

    this.subnaviLinks.forEach((element) => {
      element.addEventListener('click', (e) => {
        let navigationElement = element.parentNode.querySelector('.subpageNavigation__wrap-level2');
        if (navigationElement != null && typeof navigationElement !== 'undefined') {
          e.preventDefault();
        }
        if (!element.classList.contains('unfocus')) {
          if (element.parentNode.classList.contains('active')) {
            if (this.subNavigation.classList.contains('isSticky')) {
              document.body.style.overflow = 'auto';
            }
            Helper.removeClass(element.parentNode, 'active');
            navigationElement.style.height = '0px';
          } else {
            if (this.subNavigation.classList.contains('isSticky')) {
              document.body.style.overflow = 'hidden';
            }
            this.subnaviLinks.forEach((el) => {
              Helper.removeClass(el.parentNode, 'active');
              Helper.removeClass(el.parentNode, 'unfocus');
              let elForHeight = el.parentNode.querySelector('.subpageNavigation__wrap-level2');
              if (elForHeight != null && typeof elForHeight !== 'undefined') {
                elForHeight.style.height = '0px';
              }
            });
            navigationElement.style.height = heightOfContentContainer;
            Helper.addClass(element.parentNode, 'active');
            let openSubNavLvl2 = document.querySelector('.subpageNavigation__item.active .subpageNavigation__wrap-level2');
            openSubNavLvl2.focus({ preventScroll: true });
          }
        } else {
          Helper.removeClass(element, 'unfocus');
        }
      });
    });

    const lvl2LinksWithChildren = this.subNavigation.querySelectorAll('.menu__item--has-children > .menu__link--level-2');
    lvl2LinksWithChildren.forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        const parent = item.parentElement;
        if (parent.classList.contains('active')) {
          parent.classList.remove('active');
        } else {
          parent.classList.add('active');
        }
      });
    });

    this.suNaviItem.forEach(toggler => {
      toggler.addEventListener("mouseenter", e => {
        this.positionFloater(toggler);
      });
      toggler.addEventListener("mouseleave", e => {
        if (toggler.classList.contains('active')) {
          this.positionFloater(toggler);
        } else {
          this.positionFloater(toggler, true);
        }
      });
    });
  }

  calculateHeight(element) {
    const subnav = document.querySelector('.subpageNavigation');
    let height = '100vh';
    if (!!subnav) {
      height = 'calc(100vh - ' + subnav.offsetHeight + 'px)';
    }
    return height;
  }

  positionFloater(elementToFloatto, reset = false) {
    let floater;
    if (elementToFloatto.closest(".subpageNavigation__items-wrap")) {
      floater = elementToFloatto.closest(".subpageNavigation__items").nextElementSibling;
    }

    if (floater && floater.classList && !floater.classList.contains('is-visible')) {
      Helper.addClass(floater, "is-visible");
    }

    if (floater) {
      floater.style.left = `${elementToFloatto.getBoundingClientRect().left}px`;
      floater.style.width = elementToFloatto.offsetWidth + 'px';
    }

    if (reset) {
      floater.style.left = "0";
      floater.style.width = '7rem';
      Helper.removeClass(floater, "is-visible");
    }
  }

  // Function to add is-active class to the level 2 links based on the current URL
  addActiveClassToLinks() {
    const currentURL = window.location.href;  // Get the current URL
    this.subNavigationLinksLevel2.forEach(link => {
      if (link.href === currentURL) {  // Compare the link's href to the current URL
        Helper.addClass(link, 'is-active');

        // Find the parent .subpageNavigation__item
        const parentItem = link.closest('.subpageNavigation__item');
        if (parentItem) {
          // Only add .has-child-active if it wasn't already added
          if (!parentItem.classList.contains('has-child-active')) {
            Helper.addClass(parentItem, 'has-child-active');
          }
        }
      } else {
        Helper.removeClass(link, 'is-active');

        // Also remove the 'has-child-active' class from the parent item if no children are active
        const parentItem = link.closest('.subpageNavigation__item');
        if (parentItem) {
          const childActive = parentItem.querySelector('.is-active');
          if (!childActive) {
            Helper.removeClass(parentItem, 'has-child-active');
          }
        }
      }
    });
  }


}


export default SubnavigationFunctionality;
